// extracted by mini-css-extract-plugin
module.exports = {"base":"CardGrid-module-base","grid":"CardGrid-module-grid"};